import { forwardRef } from "react";
import {
  Field,
  FormFieldStatus,
  Hint,
  Option,
  Select,
} from "@gocardless/flux-react";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import {
  LocaleNames,
  ShorthandLocale,
  UserLocale,
} from "src/technical-integrations/i18n";
import { FieldLevelError } from "src/common/api";

interface LanguageDropdownProps {
  defaultLanguage: string;
  changeLocale: (language: string) => void;
  apiError?: FieldLevelError;
}

export const LanguageDropdown = forwardRef<
  HTMLSelectElement,
  LanguageDropdownProps
>(({ apiError, changeLocale, defaultLanguage }, ref) => {
  const { i18n } = useLingui();

  const languageOptions = Object.entries(ShorthandLocale).map(
    ([locale, shortHandLocale]) => (
      <Option
        key={shortHandLocale}
        value={shortHandLocale}
        data-testid={shortHandLocale}
      >
        {LocaleNames[locale as UserLocale]}
      </Option>
    )
  );

  return (
    <Field>
      <Select
        data-testid="select-language"
        id="language"
        ref={ref}
        name="language"
        defaultValue={defaultLanguage}
        onChange={(e) => changeLocale(e.currentTarget.value)}
      >
        {[
          <Option disabled={true} key="choose" value="choose language">
            {i18n._(
              t({
                id: "settings.user.language-settings.choose-language",
                message: "Choose language",
              })
            )}
          </Option>,
          ...languageOptions,
        ]}
      </Select>
      {apiError && (
        <Hint status={FormFieldStatus.Danger}>{apiError.message}</Hint>
      )}
    </Field>
  );
});
